import type { VariantUrlResourceType } from '~/types/graphql';

import { IPickPageType } from '~/modules/modal-pick-page/types';

/** What a picked page is stored as on the destination record. */
export const VARIANT_URL_RESOURCE_TYPE_BY_PICK_PAGE_TYPE: Record<
  IPickPageType,
  VariantUrlResourceType
> = {
  [IPickPageType.HOME]: 'INDEX',
  [IPickPageType.LANDING]: 'PAGE',
  [IPickPageType.PRODUCT]: 'PRODUCT',
  [IPickPageType.COLLECTION]: 'COLLECTION',
  [IPickPageType.BLOG_POST]: 'ARTICLE',
};

/** The tab a stored destination reads back as, so changing a page starts from where it came from. */
export const PICK_PAGE_TYPE_BY_VARIANT_URL_RESOURCE_TYPE: Record<
  VariantUrlResourceType,
  IPickPageType
> = {
  INDEX: IPickPageType.HOME,
  PAGE: IPickPageType.LANDING,
  PRODUCT: IPickPageType.PRODUCT,
  COLLECTION: IPickPageType.COLLECTION,
  ARTICLE: IPickPageType.BLOG_POST,
};
